import { CreditCardPayModel } from '../models/creditCardPay.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';

@Injectable()
export class CreditCardService extends AppService<CreditCardPayModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async register(creditCard: CreditCardPayModel) {
    const result = await this.postAsync('Cartao/CadastrarCartao', creditCard);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/credit-card.service.ts